import {CameraPosition} from '@containers/cameras/types'

export const CAMERA_POSITIONS: {value: CameraPosition; label: string}[] = [
	{value: 'UNKNOWN', label: 'Невідомо'},
	{value: 'DRIVER', label: 'Водій'},
	{value: 'FRONT_ROAD', label: 'Передня (дорога)'},
	{value: 'FRONT_DOOR', label: 'Передні двері'},
	{value: 'MIDDLE_DOOR', label: 'Середні двері'},
	{value: 'REAR_DOOR', label: 'Задні двері'},
	{value: 'SALON_FRONT', label: 'Салон передній'},
	{value: 'SALON_MIDDLE', label: 'Салон середній'},
	{value: 'SALON_REAR', label: 'Салон задній'},
	{value: 'REAR_VIEW', label: 'Задній вид'},
	{value: 'PANORAMIC', label: 'Панорама'},
	{value: 'OTHER', label: 'Інше'},
	{value: 'MULTI', label: 'Мульти'},
]

export const CAMERA_POSITION_LABELS: Record<string, string> = Object.fromEntries(
	CAMERA_POSITIONS.map(({value, label}) => [value, label])
)
